<template>
    <div id="login" :style="{background: `linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 0%, ${colors.second} 500%)`}">
       <div class="chatbot_avatar">
            <img src="../../../public/img/brad.png" alt="">
       </div>
        <div class="access_options_content" v-if="!isLogin">
            <div class="access_options">
                <button class="btn rounded" :style="{background: `linear-gradient(to right, ${colors.thirth} 0%, ${colors.first} 50%, ${colors.fourth} 100%)`}" @click="signUp">Fazer Cadastro</button>
                <button class="btn rounded outlined" :style="{color: colors.second}" @click="logIn">Já Estou Cadastrado</button>
                <div class="copyright">
                    <img src="../../../public/img/logo/huddle_copyright.png" alt="Powered by Huddle">
                </div>
            </div>
        </div>
        <div class="auth_form" v-else>
            <input type="mail" placeholder="email" v-model="form.email" :style="{color: colors.second}">
            <input type="password" placeholder="senha" v-model="form.password" @keyup.enter="auth">
            <button v-if="!isLoading" class="btn rounded" :style="{background: `linear-gradient(to right, ${colors.thirth} 0%, ${colors.first} 50%, ${colors.fourth} 100%)`}" @click="auth">Entrar</button>
            <loader v-if="isLoading"></loader>
            <span @click="logIn()">Já tem cadastro?</span>
        </div>
        <modal v-if="modal.show" @close="modal.show = false">
            <h3 slot="header">{{modal.title}}</h3>
            <h3 slot="body">{{modal.message}}</h3>
        </modal>

    </div>
</template>

<script>
import firebase from "firebase";
import Modal from '../../components/modals/Modal'
import Loader from '../../components/Loaders/CircleLoader'

export default {
    components:{
        modal: Modal,
        loader: Loader
    },

    data: () =>({
        colors: '',
        isLogin: false,
        isLoading: false,
        modal:{
            show: false,
            title: '',
            message: ''
        },
        form:{
            email: '',
            password: ''
        }
    }),

    created(){
        this.colors = this.$store.getters.getCustomColors
    },

    methods:{
        showModal(title, message){
            this.modal.title = title
            this.modal.message = message
            this.modal.show = true            
        },
        signUp(){
            this.$router.push('/create-account')
        },
        logIn(){
            this.isLogin = !this.isLogin
        },
        auth(){
            console.log('User data: ', this.form)
            this.isLoading = true
            if(this.form.email || this.form.password){
                firebase.auth().signInWithEmailAndPassword(this.form.email, this.form.password)
                    .then(response =>{
                        console.log("Response: ", response)
                        this.$store.commit('setUserInfo', {
                            id: response.user.uid,
                            email: response.user.email
                        })
                        this.isLoading = false
                        this.$router.push('/user-info')
                    }).catch(error =>{
                        console.log('Error: ', error)
                        if(this.form.email.length < 4 || this.form.password.length < 4) {
                            this.showModal('Erro de login','e-mail e/ou senha inválidos')
                            this.isLoading = false
                            return
                        }
                        if(error.code == "auth/wrong-password"){
                            this.showModal('Erro de login','senha inválida')
                            this.isLoading = false
                            return
                        }
                        if(error.code == "auth/user-not-found"){
                            this.showModal('Erro de login','e-mail não cadastrado')
                            this.isLoading = false
                            return
                        }
                    })
                return    
            }
            this.showModal('Erro de login','os campos são obrigatórios')
        }
    }
}
</script>

<style lang="scss" scoped>
    #login{
        height: 90vh;
        display: flex;
        justify-content: center;
        flex-direction: column;
        background-image: url(../../../public/img/background/pattern-background.png) !important;
        background-size: contain !important;
        background-position: top left!important;


        .chatbot_avatar{
            margin: 0 0 32px 0;
            
            img{
                max-width: 270px;
            }
        }


        .access_options, .chatbot_avatar{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
        }

        .copyright{
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;

            img{
                max-width: 60px;
                margin: 32px 0 0 0;
            }
        }

        .auth_form{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            input{
                border: 1px solid #ccc;
                border-radius: 70px;
                padding: 15px;
                width: 255px;
                // width: 60%;
                margin: 10px auto;

                &::placeholder{
                    letter-spacing: 2px;
                }
            }

            span{
                text-transform: uppercase;
                letter-spacing: 2px;
                font-size: 10px;
                margin: 10px 0 0 0;

                &:hover{
                    cursor: pointer;
                }
            }
            .btn.rounded{
                width: 125px
            }
        }
    }
</style>
